<script setup lang="ts">
const { initHuggy } = useChatWidgets()
onMounted(() => {
  if (isTelelaudo) {
    initHuggy()
  }
})
onUnmounted(() => {
  if (isTelelaudo) {
    window.Huggy?.hideButton()
  }
})
</script>

<template>
  <div>
    <AppHeader />

    <UMain>
      <slot />
    </UMain>

    <AppFooter />
  </div>
</template>
